/* Prop-Out – infopagina's: FAQ-navigatie, inhoudsopgave voorwaarden, open vraag via #anker */
(function () {
  function slug(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/&/g, ' en ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);
  }

  function activeOnScroll(links, targets) {
    if (!('IntersectionObserver' in window) || !targets.length) return;
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) current = e.target.id;
      });
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + current);
      });
    }, { rootMargin: '-20% 0px -65% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  function initFaq(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.po-faq__nav a'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.po-faq__group'));
    activeOnScroll(links, groups);
    if (location.hash) {
      var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (el && el.tagName === 'DETAILS') { el.open = true; setTimeout(function () { el.scrollIntoView({ block: 'center' }); }, 150); }
    }
  }

  function initDoc(root) {
    var body = root.querySelector('.po-doc__body');
    var toc = root.querySelector('[data-po-toc]');
    if (!body || !toc) return;
    var heads = body.querySelectorAll('h2');
    if (!heads.length) heads = body.querySelectorAll('h3');
    if (heads.length < 2) { toc.remove(); return; }
    root.classList.add('po-doc--toc');
    var ol = document.createElement('ol');
    var links = [];
    Array.prototype.forEach.call(heads, function (h, i) {
      if (!h.id) h.id = slug(h.textContent) || ('artikel-' + (i + 1));
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a); ol.appendChild(li); links.push(a);
    });
    toc.appendChild(ol);
    activeOnScroll(links, Array.prototype.slice.call(heads));
  }

  function init() {
    document.querySelectorAll('.po-faq').forEach(initFaq);
    document.querySelectorAll('.po-doc').forEach(initDoc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
